export default {
  SECTION_TITLE: 'sectionTitle',
  CONTENT: 'content',
  RSS_FIELD_URL: 'rssFeedUrl'
};
